export default "__VITE_ASSET__C9e2k60L__"